// NOSONAR
export function initGTM(gtmId: string): void {
    const w = window as Window & { dataLayer?: unknown[] };
    const d = document;
    const l = 'dataLayer';

    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

    const f = d.getElementsByTagName('script')[0];
    const j = d.createElement('script');
    j.async = true;
    j.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    f.parentNode?.insertBefore(j, f);
}
